import './Home.css';
import heroImage from '../../assets/images/Norrtra-logo-v1-final-2-radavstand-negativ.png';

function Home() {
  return (
    <div className="home">
        <div className="infoBox">
        <img className="img" src={heroImage} alt="Norrträ Bygg logo"></img>
        <h1>Här byggs det för fullt – både ute och på webben.</h1>
        <p>En ny hemsida är på gång!</p>
        <p>Tills dess hittar du bilder och projekt på <a href="https://www.instagram.com/norrtrabygg/">Instagram</a>.</p>

        <p>
            Du kan också nå mig på <a href="tel:+46702155167">070‑215 51 67</a> eller via <a href="mailto:marcus@norrtrabygg.se">e‑post</a>.
        </p>
    </div>
    </div>
  );
}

export default Home;